import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* לוגו וטקסט */}
          <div>
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-md">
                <span className="text-primary-600 font-bold text-2xl">D.I</span>
              </div>
              <div className="mr-4">
                <h3 className="text-xl font-bold mb-1">D.I.Technologies</h3>
                <span className="text-sm text-gray-400">ד.י.טכנולוגיה</span>
              </div>
            </div>
            <p className="text-gray-300">
              פתרונות הלחמה מקצועיים ברמה הגבוהה ביותר
            </p>
          </div>

          {/* קישורים מהירים */}
          <div>
            <h4 className="text-lg font-semibold mb-4">ניווט מהיר</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors">
                  דף הבית
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-white transition-colors">
                  שירותים
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors">
                  צור קשר
                </Link>
              </li>
            </ul>
          </div>

          {/* פרטי קשר */}
          <div>
            <h4 className="text-lg font-semibold mb-4">צור קשר</h4>
            <div className="space-y-2 text-gray-300">
              <p>טלפון: 050-973-9003</p>
              <p>אימייל: dina@ditech.co.il</p>
              <p>כתובת: ברזילי 19 קריית ים, ישראל</p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
          <p>© {new Date().getFullYear()} D.I.Technologies. כל הזכויות שמורות.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 